// Historical model JSON is adapted once. Renderers consume plain content + metadata.
export function normalizeAgentMessage(message) {
  if (!message || message.role === 'user' || message.type === 'user') return message;
  let content = typeof message.content === 'string' ? message.content : '';
  const metadata = { ...(message.metadata || {}) };
  let legacy = null;
  if (metadata.protocol_version !== 2 && content.trim().startsWith('{')) {
    try {
      const parsed = JSON.parse(content);
      if (parsed && typeof parsed.final_message === 'string') legacy = parsed;
    } catch (_) {
      // Incomplete/invalid legacy content remains text; it is never regex-repaired.
    }
  }
  if (legacy) {
    content = legacy.final_message;
    metadata.tool_calls = metadata.tool_calls || legacy.tool_calls || [];
    metadata.follow_up_actions =
      metadata.follow_up_actions ||
      legacy.follow_up_actions ||
      legacy['follow_up_actions:'] ||
      legacy.follow_up_questions ||
      legacy['follow_up_questions:'] ||
      [];
    metadata.reasoning_summary = metadata.reasoning_summary || legacy.reasoning_summary || legacy.reasoning_text || legacy.reasoning || '';
  }
  if (!legacy && !message.metadata) return message;
  metadata.follow_up_actions = (Array.isArray(metadata.follow_up_actions) ? metadata.follow_up_actions : [])
    .filter((value) => typeof value === 'string' && value.trim())
    .slice(0, 6);
  if (!Array.isArray(metadata.tool_calls)) metadata.tool_calls = [];
  return { ...message, content, metadata };
}

export function normalizeAgentThread(thread) {
  if (!Array.isArray(thread?.messages?.items)) return thread;
  return { ...thread, messages: { ...thread.messages, items: thread.messages.items.map(normalizeAgentMessage) } };
}
